import * as React from 'react';

export interface TableToolbarProps {
  dataHook?: string;
  children?: React.ReactNode;
  className?: string;
  removeVerticalPadding?: boolean;
}

interface ItemGroupProps {
  dataHook?: string;
  children?: React.ReactNode;
  className?: string;
  position?: string;
}

interface ItemProps {
  dataHook?: string;
  children?: React.ReactNode;
  className?: string;
  layout?: 'button';
}

interface TitleProps {
  children?: React.ReactNode;
  className?: string;
  dataHook?: string;
}

interface LabelProps {
  children?: React.ReactNode;
  className?: string;
  dataHook?: string;
}

interface DividerProps {
  children?: React.ReactNode;
  className?: string;
  dataHook?: string;
}

interface SelectedCountProps {
  children?: React.ReactNode;
  className?: string;
  dataHook?: string;
}

declare const ItemGroup: React.FC<ItemGroupProps>;
declare const Item: React.FC<ItemProps>;
declare const Title: React.FC<TitleProps>;
declare const Label: React.FC<LabelProps>;
declare const Divider: React.FC<DividerProps>;
declare const SelectedCount: React.FC<SelectedCountProps>;

export declare const TableToolbar: React.FC<TableToolbarProps> & {
  ItemGroup: typeof ItemGroup;
  Item: typeof Item;
  Title: typeof Title;
  Label: typeof Label;
  Divider: typeof Divider;
  SelectedCount: typeof SelectedCount;
};

export default TableToolbar;
